<template>
  <form @submit.prevent="handleSubmit" data-testid="site-unidades-form">
    <tab-view v-model="activeTab">
      <template #tablist>
        <TabList>
          <Tab value="0" data-testid="site-unidades-tab-identificacao">{{ t('Identificação') }}</Tab>
          <Tab value="1" data-testid="site-unidades-tab-endereco">{{ t('Endereço') }}</Tab>
          <Tab value="2" data-testid="site-unidades-tab-contato">{{ t('Contato') }}</Tab>
          <Tab value="4" data-testid="site-unidades-tab-horarios">{{ t('Horários') }}</Tab>
          <Tab value="5" data-testid="site-unidades-tab-fotos">{{ t('Fotos') }}</Tab>
          <Tab value="6" data-testid="site-unidades-tab-rastreamento">{{ t('Rastreamento') }}</Tab>
        </TabList>
      </template>
        <!-- Identificação -->
        <TabViewPanel value="0">
          <div class="form-field">
            <input-text
              elem-id="siteUnidadeSlug"
              v-model="formData.slug"
              :label="t('Endereço na URL (slug)')"
              :placeholder="t('slug-da-unidade')"
              type="text"
              required
              fluid
              data-testid="site-unidades-slug-input"
            />
            <small v-if="errors.slug" class="error-message" data-testid="site-unidades-slug-error">{{ errors.slug }}</small>
          </div>
          <div class="form-field">
            <input-text
              elem-id="siteUnidadeNomePt"
              v-model="formData.nome['pt-BR']"
              :label="t('Nome (pt-BR)')"
              type="text"
              required
              fluid
              data-testid="site-unidades-nome-pt-input"
            />
            <small v-if="errors.nome" class="error-message" data-testid="site-unidades-nome-error">{{ errors.nome }}</small>
          </div>
          <div class="form-field">
            <input-text
              elem-id="siteUnidadeNomeEn"
              v-model="formData.nome['en-US']"
              :label="t('Nome (en-US)')"
              type="text"
              fluid
              data-testid="site-unidades-nome-en-input"
            />
          </div>
          <div class="form-field">
            <input-text
              elem-id="siteUnidadeNomeEs"
              v-model="formData.nome['es-ES']"
              :label="t('Nome (es-ES)')"
              type="text"
              fluid
              data-testid="site-unidades-nome-es-input"
            />
          </div>
          <div class="form-field">
            <franchise-select
              elem-id="siteUnidadeFranquiaId"
              v-model="formData.franquia_id"
              :label="t('Franquia')"
              :placeholder="t('Selecione a franquia (opcional)')"
              data-testid="site-unidades-franquia-select"
            />
          </div>
          <div class="form-field">
            <select-list
              elem-id="siteUnidadeStatus"
              v-model="formData.status"
              :label="t('Status')"
              :itens-select="statusOptions"
              data-testid="site-unidades-status-select"
            />
          </div>
        </TabViewPanel>

        <!-- Endereço -->
        <TabViewPanel value="1">
          <div class="form-field">
            <input-text elem-id="siteUnidadeEnderecoPt" v-model="formData.endereco['pt-BR']" :label="t('Endereço (pt-BR)')" type="text" fluid data-testid="site-unidades-endereco-pt-input" />
          </div>
          <div class="form-field">
            <input-text elem-id="siteUnidadeEnderecoEn" v-model="formData.endereco['en-US']" :label="t('Endereço (en-US)')" type="text" fluid data-testid="site-unidades-endereco-en-input" />
          </div>
          <div class="form-field">
            <input-text elem-id="siteUnidadeEnderecoEs" v-model="formData.endereco['es-ES']" :label="t('Endereço (es-ES)')" type="text" fluid data-testid="site-unidades-endereco-es-input" />
          </div>
          <div class="form-field">
            <input-text elem-id="siteUnidadeCidade" v-model="formData.cidade" :label="t('Cidade')" type="text" fluid data-testid="site-unidades-cidade-input" />
          </div>
          <div class="form-field">
            <input-text elem-id="siteUnidadeEstado" v-model="formData.estado" :label="t('Estado')" type="text" fluid data-testid="site-unidades-estado-input" />
          </div>
          <div class="form-field">
            <input-text elem-id="siteUnidadePais" v-model="formData.pais" :label="t('País')" type="text" fluid data-testid="site-unidades-pais-input" />
          </div>
          <div class="form-field">
            <input-number elem-id="siteUnidadeLatitude" v-model="formData.latitude" :label="t('Latitude')" data-testid="site-unidades-latitude-input" />
          </div>
          <div class="form-field">
            <input-number elem-id="siteUnidadeLongitude" v-model="formData.longitude" :label="t('Longitude')" data-testid="site-unidades-longitude-input" />
          </div>
          <div class="form-field">
            <input-toggle elem-id="siteUnidadeCoordsLock" v-model="formData.coords_lock" :label="t('Travar coordenadas')" data-testid="site-unidades-coords-lock-toggle" />
          </div>
        </TabViewPanel>

        <!-- Contato -->
        <TabViewPanel value="2">
          <div class="form-field">
            <input-text elem-id="siteUnidadeWhatsapp" v-model="formData.whatsapp" :label="t('WhatsApp')" type="text" fluid data-testid="site-unidades-whatsapp-input" />
          </div>
          <div class="form-field">
            <input-text elem-id="siteUnidadeWhatsappSemTracos" v-model="formData.whatsapp_sem_tracos" :label="t('WhatsApp (sem traços)')" type="text" fluid data-testid="site-unidades-whatsapp-sem-tracos-input" />
          </div>
          <div class="form-field">
            <input-text elem-id="siteUnidadeInstagram" v-model="formData.instagram" :label="t('Instagram')" type="text" fluid data-testid="site-unidades-instagram-input" />
          </div>
          <div class="form-field">
            <input-text elem-id="siteUnidadeFacebook" v-model="formData.facebook" :label="t('Facebook')" type="text" fluid data-testid="site-unidades-facebook-input" />
          </div>
          <div class="form-field">
            <input-text elem-id="siteUnidadeTiktok" v-model="formData.tiktok" :label="t('TikTok')" type="text" fluid data-testid="site-unidades-tiktok-input" />
          </div>
        </TabViewPanel>

        <!-- Horários -->
        <TabViewPanel value="4">
          <div class="form-field">
            <input-text elem-id="siteUnidadeHorarioSemanaAbre" v-model="formData.horario_semana_abre" :label="t('Semana - Abre')" placeholder="09:00" type="text" fluid data-testid="site-unidades-horario-semana-abre-input" />
          </div>
          <div class="form-field">
            <input-text elem-id="siteUnidadeHorarioSemanaFecha" v-model="formData.horario_semana_fecha" :label="t('Semana - Fecha')" placeholder="18:00" type="text" fluid data-testid="site-unidades-horario-semana-fecha-input" />
          </div>
          <div class="form-field">
            <input-text elem-id="siteUnidadeHorarioSabadoAbre" v-model="formData.horario_sabado_abre" :label="t('Sábado - Abre')" placeholder="09:00" type="text" fluid data-testid="site-unidades-horario-sabado-abre-input" />
          </div>
          <div class="form-field">
            <input-text elem-id="siteUnidadeHorarioSabadoFecha" v-model="formData.horario_sabado_fecha" :label="t('Sábado - Fecha')" placeholder="13:00" type="text" fluid data-testid="site-unidades-horario-sabado-fecha-input" />
          </div>
        </TabViewPanel>

        <!-- Fotos -->
        <TabViewPanel value="5">
          <div class="form-field">
            <input-text elem-id="siteUnidadeImagemAlt" v-model="formData.imagem_alt" :label="t('Texto alternativo da imagem')" type="text" fluid data-testid="site-unidades-imagem-alt-input" />
          </div>
          <div class="form-field">
            <label class="picker-label">{{ t('Capa') }}</label>
            <site-unidades-photo-picker
              v-model="formData.imagem_url"
              test-id-prefix="site-unidades-capa"
            />
          </div>

          <h4>{{ t('Galeria') }} ({{ galeria.length }}/4)</h4>
          <div v-for="(foto, idx) in galeria" :key="idx" class="repeatable-row" :data-testid="`site-unidades-galeria-row-${idx}`">
            <site-unidades-photo-picker
              v-model="foto.foto_url"
              :test-id-prefix="`site-unidades-galeria-${idx}`"
            />
            <input-text :elem-id="`siteUnidadeGaleriaAlt${idx}`" v-model="foto.foto_alt" :label="t('Texto alternativo')" type="text" fluid :data-testid="`site-unidades-galeria-alt-input-${idx}`" />
            <Button
              icon="pi pi-trash"
              size="small"
              class="p-button-outlined p-button-danger"
              :label="t('Remover')"
              :data-testid="`site-unidades-galeria-remove-${idx}`"
              @click="removeGaleriaFoto(idx)"
            />
          </div>
          <Button
            icon="pi pi-plus"
            size="small"
            class="p-button-outlined"
            :label="t('Adicionar foto')"
            :disabled="galeria.length >= 4"
            data-testid="site-unidades-galeria-add"
            @click="addGaleriaFoto"
          />
        </TabViewPanel>

        <!-- Rastreamento: as tags DA UNIDADE (disparam na página dela em todo domínio da marca) -->
        <TabViewPanel value="6">
          <div class="form-field">
            <input-text elem-id="siteUnidadeTrackingAds" v-model="formData.tracking_google_ads_ids" :label="t('IDs de conversão do Google Ads')" placeholder="AW-18438283309, AW-18474445599" type="text" fluid data-testid="site-unidades-tracking-ads-input" />
          </div>
          <div class="form-field">
            <input-text elem-id="siteUnidadeTrackingPixel" v-model="formData.tracking_meta_pixel" :label="t('Pixel do Meta')" placeholder="685256758663339" type="text" fluid data-testid="site-unidades-tracking-pixel-input" />
          </div>
          <div class="form-field">
            <input-text elem-id="siteUnidadeTrackingGtm" v-model="formData.tracking_gtm_extra" :label="t('Container GTM próprio da unidade')" placeholder="GTM-XXXXXXX" type="text" fluid data-testid="site-unidades-tracking-gtm-input" />
          </div>
          <small v-if="errors.tracking" class="error-message" data-testid="site-unidades-tracking-error">{{ errors.tracking }}</small>
        </TabViewPanel>
    </tab-view>
  </form>
</template>

<script setup lang="ts">
import { ref, reactive, computed, onMounted, watch, nextTick } from 'vue';
import { useI18n } from 'vue-i18n';
import TabView from '../../ui/TabView.vue';
import TabViewPanel from '../../ui/TabViewPanel.vue';
import InputText from '../../inputs/InputText.vue';
import InputNumber from '../../inputs/InputNumber.vue';
import InputToggle from '../../inputs/InputToggle.vue';
import SelectList from '../../inputs/SelectList.vue';
import FranchiseSelect from '../../inputs/FranchiseSelect.vue';
import { useSiteUnidades } from '../../composables/useSiteUnidades';
import type { SiteUnidades_SalvarInput } from '../../contracts/SiteUnidades_SalvarInput';
import type { SiteUnidades_GaleriaFotoInput } from '../../contracts/SiteUnidades_GaleriaFotoInput';
import { eventBus } from '../../eventBus';
import { log, warn as logWarn, error as logError } from '../../utils/DebugLogger';

type UnidadeId = number | string | null;

interface ApiError extends Error {
  response?: {
    data?: {
      error?: string;
    };
  };
}

const props = withDefaults(defineProps<{
  unidadeId?: UnidadeId;
  isEditMode?: boolean;
}>(), {
  unidadeId: null,
  isEditMode: false
});

const emit = defineEmits<{
  'submit-success': [];
  'submit-error': [error: unknown];
  'validation-failed': [];
}>();

const { t } = useI18n();

const { fetchUnidade, salvarUnidade } = useSiteUnidades();

const activeTab = ref<string>('0');

const unidadeIdNumber = computed<number | null>(() => {
  if (!props.unidadeId) return null;
  return typeof props.unidadeId === 'string' ? parseInt(props.unidadeId, 10) : props.unidadeId;
});

const emptyLocaleMap = (): Record<string, string> => ({ 'pt-BR': '', 'en-US': '', 'es-ES': '' });

interface FormShape {
  slug: string;
  nome: Record<string, string>;
  franquia_id: number | null;
  status: string;
  endereco: Record<string, string>;
  cidade: string;
  estado: string;
  pais: string;
  latitude: number | null;
  longitude: number | null;
  coords_lock: boolean;
  whatsapp: string;
  whatsapp_sem_tracos: string;
  instagram: string;
  facebook: string;
  tiktok: string;
  horario_semana_abre: string;
  horario_semana_fecha: string;
  horario_sabado_abre: string;
  horario_sabado_fecha: string;
  imagem_url: string;
  imagem_alt: string;
  tracking_google_ads_ids: string;
  tracking_meta_pixel: string;
  tracking_gtm_extra: string;
}

const buildEmptyForm = (): FormShape => ({
  slug: '',
  nome: emptyLocaleMap(),
  franquia_id: null,
  status: 'em_breve',
  endereco: emptyLocaleMap(),
  cidade: '',
  estado: '',
  pais: '',
  latitude: null,
  longitude: null,
  coords_lock: false,
  whatsapp: '',
  whatsapp_sem_tracos: '',
  instagram: '',
  facebook: '',
  tiktok: '',
  horario_semana_abre: '',
  horario_semana_fecha: '',
  horario_sabado_abre: '',
  horario_sabado_fecha: '',
  imagem_url: '',
  imagem_alt: '',
  tracking_google_ads_ids: '',
  tracking_meta_pixel: '',
  tracking_gtm_extra: ''
});

// Local row shape keeps foto_alt required-non-optional for the template's
// v-model bindings; buildPayload() maps it onto the (looser) generated
// contract type when saving.
interface GaleriaFotoRow {
  foto_url: string;
  foto_alt: string;
}

const formData = reactive<FormShape>(buildEmptyForm());
const galeria = reactive<GaleriaFotoRow[]>([]);

const errors = reactive<{ slug: string; nome: string; tracking: string }>({ slug: '', nome: '', tracking: '' });

// The unit's tags (plano site-doutor-dominios-espelho, B4) — the same formats the backend enforces.
const parseAdsIds = (raw: string): string[] => [
  ...new Set(raw.split(/[\s,;]+/).map(id => id.trim().toUpperCase()).filter(id => id !== '')),
];
const ADS_ID = /^AW-\d{6,14}$/;
const META_PIXEL = /^\d{8,20}$/;
const GTM_ID = /^GTM-[A-Z0-9]{4,12}$/;

const isLoading = ref<boolean>(false);

const statusOptions = computed(() => [
  { ID: 'aberta', Name: t('Aberta') },
  { ID: 'em_breve', Name: t('Em breve') }
]);

const addGaleriaFoto = (): void => {
  if (galeria.length >= 4) return;
  galeria.push({ foto_url: '', foto_alt: '' });
};

const removeGaleriaFoto = (idx: number): void => {
  galeria.splice(idx, 1);
};

const loadForEdit = async (): Promise<void> => {
  if (!unidadeIdNumber.value) {
    logWarn('SiteUnidadesForm', 'loadForEdit', 'No unidadeId provided');
    return;
  }

  log('SiteUnidadesForm', 'loadForEdit', 'Loading unit for edit', unidadeIdNumber.value);
  isLoading.value = true;

  try {
    const unidade = await fetchUnidade(unidadeIdNumber.value);
    log('SiteUnidadesForm', 'loadForEdit', 'Loaded unit data', unidade);

    if (!unidade) {
      throw new Error('Dados da unidade não encontrados');
    }

    formData.slug = (unidade.slug as string) || '';
    formData.nome = { ...emptyLocaleMap(), ...(unidade.nome as Record<string, string> | undefined) };
    formData.franquia_id = (unidade.franquia_id as number | null) ?? null;
    formData.status = (unidade.status as string) || 'em_breve';
    formData.endereco = { ...emptyLocaleMap(), ...(unidade.endereco as Record<string, string> | undefined) };
    formData.cidade = (unidade.cidade as string) || '';
    formData.estado = (unidade.estado as string) || '';
    formData.pais = (unidade.pais as string) || '';
    formData.latitude = (unidade.latitude as number | null) ?? null;
    formData.longitude = (unidade.longitude as number | null) ?? null;
    formData.coords_lock = !!unidade.coords_lock;
    formData.whatsapp = (unidade.whatsapp as string) || '';
    formData.whatsapp_sem_tracos = (unidade.whatsapp_sem_tracos as string) || '';
    formData.instagram = (unidade.instagram as string) || '';
    formData.facebook = (unidade.facebook as string) || '';
    formData.tiktok = (unidade.tiktok as string) || '';
    formData.horario_semana_abre = (unidade.horario_semana_abre as string) || '';
    formData.horario_semana_fecha = (unidade.horario_semana_fecha as string) || '';
    formData.horario_sabado_abre = (unidade.horario_sabado_abre as string) || '';
    formData.horario_sabado_fecha = (unidade.horario_sabado_fecha as string) || '';
    formData.imagem_url = (unidade.imagem_url as string) || '';
    formData.imagem_alt = (unidade.imagem_alt as string) || '';
    const tracking = (unidade.tracking ?? {}) as { google_ads_ids?: string[]; meta_pixel?: string | null; gtm_extra?: string | null };
    formData.tracking_google_ads_ids = (tracking.google_ads_ids ?? []).join(', ');
    formData.tracking_meta_pixel = tracking.meta_pixel || '';
    formData.tracking_gtm_extra = tracking.gtm_extra || '';

    galeria.splice(0, galeria.length, ...(((unidade.galeria as SiteUnidades_GaleriaFotoInput[]) || []).map(f => ({
      foto_url: f.foto_url || '',
      foto_alt: f.foto_alt || ''
    }))));

    clearErrors();
  } catch (err) {
    const error = err as ApiError;
    logError('SiteUnidadesForm', 'loadForEdit', 'Error loading unit', {
      unidadeId: unidadeIdNumber.value,
      error: error.message,
      stack: error.stack,
      response: error.response
    });

    const errorMessage = error.response?.data?.error || error.message || 'Erro desconhecido';
    eventBus.emit('globalMessage.error', t('Erro ao carregar unidade') + ': ' + errorMessage);
    emit('submit-error', error);
  } finally {
    isLoading.value = false;
  }
};

const validateForm = (): boolean => {
  log('SiteUnidadesForm', 'validateForm', 'Validating form');
  clearErrors();
  let isValid = true;

  if (!formData.slug || formData.slug.trim() === '') {
    errors.slug = t('Campo obrigatório');
    isValid = false;
  }

  if (!formData.nome['pt-BR'] || formData.nome['pt-BR'].trim() === '') {
    errors.nome = t('Campo obrigatório');
    isValid = false;
  }

  const badAds = parseAdsIds(formData.tracking_google_ads_ids).filter(id => !ADS_ID.test(id));
  const pixel = formData.tracking_meta_pixel.trim();
  const gtm = formData.tracking_gtm_extra.trim().toUpperCase();
  if (badAds.length > 0 || (pixel !== '' && !META_PIXEL.test(pixel)) || (gtm !== '' && !GTM_ID.test(gtm))) {
    errors.tracking = badAds.length > 0
      ? t('ID do Google Ads inválido (use AW- seguido de números)') + ': ' + badAds.join(', ')
      : t('Pixel do Meta só com números; container GTM no formato GTM-XXXXXXX');
    activeTab.value = '6';
    isValid = false;
  }

  log('SiteUnidadesForm', 'validateForm', 'Validation result', isValid);
  return isValid;
};

const clearErrors = (): void => {
  errors.slug = '';
  errors.nome = '';
  errors.tracking = '';
};

const resetForm = (): void => {
  log('SiteUnidadesForm', 'resetForm', 'Resetting form');
  Object.assign(formData, buildEmptyForm());
  galeria.splice(0, galeria.length);
  activeTab.value = '0';
  clearErrors();
};

const buildPayload = (): SiteUnidades_SalvarInput => {
  // franquia_id is OPTIONAL (decisão 2026-09-02). Clearing the select emits an
  // empty string, so anything non-positive travels as null.
  const franquiaId = Number(formData.franquia_id);
  const payload: SiteUnidades_SalvarInput = {
    franquia_id: Number.isFinite(franquiaId) && franquiaId > 0 ? franquiaId : undefined,
    slug: formData.slug.trim(),
    nome: { ...formData.nome },
    status: formData.status,
    endereco: { ...formData.endereco },
    cidade: formData.cidade,
    estado: formData.estado,
    pais: formData.pais,
    coords_lock: formData.coords_lock,
    whatsapp: formData.whatsapp,
    whatsapp_sem_tracos: formData.whatsapp_sem_tracos,
    instagram: formData.instagram,
    facebook: formData.facebook,
    tiktok: formData.tiktok,
    horario_semana_abre: formData.horario_semana_abre,
    horario_semana_fecha: formData.horario_semana_fecha,
    horario_sabado_abre: formData.horario_sabado_abre,
    horario_sabado_fecha: formData.horario_sabado_fecha,
    imagem_url: formData.imagem_url,
    imagem_alt: formData.imagem_alt,
    // The generated SiteUnidades_SalvarInput types galeria as undefined[]
    // (the PHP contract declares it as an untyped array of a nested
    // InputContract, which the TS generator doesn't expand inline); the
    // real shape is SiteUnidades_GaleriaFotoInput[].
    galeria: galeria.filter(f => f.foto_url && f.foto_url.trim() !== '') as unknown as SiteUnidades_SalvarInput['galeria'],
    // Always sent, so clearing a field here clears it on the server (absent would keep the stored tags).
    tracking: {
      google_ads_ids: parseAdsIds(formData.tracking_google_ads_ids),
      ...(formData.tracking_meta_pixel.trim() !== '' ? { meta_pixel: formData.tracking_meta_pixel.trim() } : {}),
      ...(formData.tracking_gtm_extra.trim() !== '' ? { gtm_extra: formData.tracking_gtm_extra.trim().toUpperCase() } : {}),
    }
  };

  if (formData.latitude != null) {
    payload.latitude = formData.latitude;
  }
  if (formData.longitude != null) {
    payload.longitude = formData.longitude;
  }
  if (props.isEditMode && unidadeIdNumber.value) {
    payload.id = unidadeIdNumber.value;
  }

  return payload;
};

const handleSubmit = async (): Promise<void> => {
  log('SiteUnidadesForm', 'handleSubmit', 'Form submitted');

  if (!validateForm()) {
    logWarn('SiteUnidadesForm', 'handleSubmit', 'Validation failed');
    emit('validation-failed');
    return;
  }

  isLoading.value = true;

  try {
    const payload = buildPayload();
    log('SiteUnidadesForm', 'handleSubmit', 'Saving unit', payload);
    await salvarUnidade(payload);
    eventBus.emit('globalMessage.success', props.isEditMode ? t('Unidade atualizada com sucesso') : t('Unidade criada com sucesso'));

    emit('submit-success');
    resetForm();
  } catch (err) {
    const error = err as Error;
    logError('SiteUnidadesForm', 'handleSubmit', 'Error submitting form', error);
    eventBus.emit('globalMessage.error',
      props.isEditMode
        ? t('Erro ao atualizar unidade') + ': ' + error.message
        : t('Erro ao criar unidade') + ': ' + error.message
    );
    emit('submit-error', error);
  } finally {
    isLoading.value = false;
  }
};

watch(() => props.unidadeId, async (newId) => {
  log('SiteUnidadesForm', 'watch', 'unidadeId changed', { newId, isEditMode: props.isEditMode });
  if (newId && props.isEditMode) {
    await nextTick();
    await loadForEdit();
  }
});

onMounted(() => {
  log('SiteUnidadesForm', 'mounted', 'Component mounted', {
    unidadeId: props.unidadeId,
    unidadeIdNumber: unidadeIdNumber.value,
    isEditMode: props.isEditMode
  });

  if (props.isEditMode && unidadeIdNumber.value) {
    loadForEdit();
  }
});

defineExpose({
  loadForEdit,
  handleSubmit,
  resetForm,
  validateForm
});
</script>

<style scoped>
.form-field {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.error-message {
  color: var(--p-red-500);
  font-size: 0.875rem;
  margin-top: 0.25rem;
  display: block;
}

.repeatable-row {
  display: flex;
  align-items: flex-end;
  gap: 0.5rem;
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid var(--p-surface-200);
}

.picker-label {
  font-weight: 600;
  font-size: 0.875rem;
}
</style>
